/* global Blockonomics */
import React, { useEffect, useRef, useState }  from 'react';
import CurrencySelector from './CurrencySelector';
import ExampleTicket from './ExampleTicketPresentation';
import PaypalButton from './PaypalCheckoutButton';
import * as constClass from '../../constants/agent.js';
import { FlightTicket } from '../../utils/requests';


import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Collapse from 'react-bootstrap/Collapse';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { useNavigate } from "react-router-dom";


function PayWhatYouWantCheckout(props) {
  //////////////////////////////////////////////////////////
  // State
  const [tabKey, setTabKey] = useState('basic');
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingStripe, setIsLoadingStripe] = useState(false);
  const [isLoadingBitcoin, setIsLoadingBitcoin] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");

  // State Free Ticket
  const upgradeDialogRef = useRef(null);
  const [showUpgradeDialog, setShowUpgradeDialog] = useState(false);

  // State Pro Ticket
  const [extraPassengers, setExtraPassengers] = useState([{"name": ""}]);
  const [currency, setCurrency] = useState("");
  const [optionalPnrNumber, setOptionalPnrNumber] = useState("");
  const [flightClass, setFlightClass] = useState("economy");
  const [openProSettings, setOpenProSettings] = useState(false);
  const [blockonomicsUid, setBlockonomicsUid] = useState(null);
  const [showBlockonomicsWidget, setShowBlockonomicsWidget] = useState(false);
  //////////////////////////////////////////////////////////

  // Simple price constant used across labels
  const PRO_PRICE_USD = 5;

  // Routing
  const navigate = useNavigate();
  
    //////////////////////////////////////////////////////////
  // Hooks

  // Scroll to upgrade dialog when showUpgradeDialog becomes true
  useEffect(() => {
    if (showUpgradeDialog && upgradeDialogRef.current) {
      upgradeDialogRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [showUpgradeDialog]);

  // Auto-fetch Blockonomics UID when modal opens
  useEffect(() => {
    if (props.is_visible && !blockonomicsUid) {
      handleCheckout("coinbase");
    }
  }, [props.is_visible]);

  //////////////////////////////////////////////////////////
  // Functions

  // Resolve the Blockonomics API regardless of how the script exposes it
  const getBlockonomicsApi = () => {
    const api = (typeof Blockonomics !== 'undefined'
      ? Blockonomics
      : (typeof window !== 'undefined' ? window.Blockonomics : undefined));
    return api && typeof api.widget === 'function' ? api : null;
  };

  const closeBlockonomicsWidget = () => {
    // Clear widget container
    const widgetContainer = document.getElementById('blockonomics_widget');
    if (widgetContainer) {
      widgetContainer.innerHTML = '';
    }
    setShowBlockonomicsWidget(false);
  };

  const openBlockonomicsWidgetSimple = () => {
    if (!blockonomicsUid) {
      setAlertType('warning');
      setAlertMessage('Preparing Bitcoin payment... please try again in a moment.');
      setShowAlert(true);
      return;
    }
    // Toggle widget: if already showing, close it
    if (showBlockonomicsWidget) {
      closeBlockonomicsWidget();
      return;
    }
    const blockonomicsApi = getBlockonomicsApi();
    if (!blockonomicsApi) {
      setAlertType('danger');
      setAlertMessage('Bitcoin widget is not available. Disable blockers and reload.');
      setShowAlert(true);
      return;
    }
    if (typeof window.blockonomicsPaymentCallback !== 'function') {
      window.blockonomicsPaymentCallback = function(payment) {
        setAlertType("success");
        setAlertMessage(
          <div className="text-center">
            <i className="bi bi-check-circle text-success"></i>
            <h5>Bitcoin Payment Received!</h5>
            <p>Amount: {(payment.value/1e8).toFixed(8)} BTC</p>
            <p>Transaction ID: {payment.txid}</p>
            <Button 
              variant="primary" 
              onClick={() => {
                setShowBlockonomicsWidget(false);
                setShowAlert(false);
                navigate("/checkout-success", {state : { email: props.customer_data.email }});
              }}
            >
              Continue to Ticket
            </Button>
          </div>
        );
        setShowAlert(true);
      };
    }
    // Clear widget container before creating new instance
    const widgetContainer = document.getElementById('blockonomics_widget');
    if (widgetContainer) {
      widgetContainer.innerHTML = '';
    }
    // Open widget after user clicks the button
    setShowBlockonomicsWidget(true);
    blockonomicsApi.widget({
      msg_area: 'blockonomics_widget',
      uid: blockonomicsUid,
      email: props.customer_data.email
    });
  };

  // Open widget only on button click per UX
  //////////////////////////////////////////////////////////

  const handleDonateButtonClick = () => {
    setTabKey("pro");
    setAlertType("success");
  }

  const handleGetFreeTicket = () => {
    setShowUpgradeDialog(false);
    handleCheckout("free");
  };

  const handleCheckout = async (checkoutType) => {
      setIsLoading(true);
      // Customer data
      const {
        first_name,
        last_name,
        email} = props.customer_data;
      // Flight data
      const {
        airline,
        arrival_time,
        city_from,
        city_to,
        departure_time,
        flight_name,
        fly_duration,
        fly_from,
        fly_to,
        price,
        route} = props.flight_data;
      // Extra data
      const {
        subscribe_to_newsletter
      } = props.extra_data;

    // Free option
    if (checkoutType === "free") {
      // POST to free endpoint
      const response = await FlightTicket.orderTicketFree(
        first_name,
        last_name,
        email,
        airline,
        arrival_time,
        city_from,
        city_to,
        departure_time,
        flight_name,
        fly_duration,
        fly_from,
        fly_to,
        price,
        route,
        subscribe_to_newsletter
      )
      //console.log("Received free ticket")
      if (response.status === 200) {
        // Navigate to success page
        navigate("/checkout-success", {state : { email: email }})
      } else if (response.status === 429) {
        // Rate limit reached
        const msg = 
        <div className="text-center">
          <Button variant="light" onClick={() => handleDonateButtonClick()}>
            <span className="badge badge-light">Get Pro Ticket</span>
          </Button>
          <hr/>
          You've hit the limit of free tickets for today (2/day).
        </div>
        setAlertType("warning");
        setAlertMessage(msg);
        setShowAlert(true);
        //navigate("/error", {state : { error_msg: response.statusText }})
      }
    }
    // Payment option
    else if (checkoutType === "stripe") {
        setIsLoadingStripe(true);
        // POST to create stripe checkout session
        const response = await FlightTicket.orderTicketStripe(
          first_name,
          last_name,
          email,
          airline,
          arrival_time,
          city_from,
          city_to,
          departure_time,
          flight_name,
          fly_duration,
          fly_from,
          fly_to,
          price,
          route,
          subscribe_to_newsletter,
          "5", // 5 times 1$ ticket price
          // Pro ticket extra options
          extraPassengers,
          currency,
          optionalPnrNumber,
          flightClass
        )
        
        // ToDo implement status code handling here!
        // Otherwise I fail here if django doesn't return 200
        // Also set isLoadingStripe to false if django doesn't return 200
        // Receive stripe checkout URL from django
        const stripe_checkout_redirect_url = await response.json();
        setIsLoadingStripe(false);
        // Redirect to stripe checkout
        window.open(stripe_checkout_redirect_url);
    }
    else if (checkoutType === "coinbase") {
        // console.log("[*] Crypto Checkout")
        setIsLoadingBitcoin(true);
        try {
        // POST to create Coinbase charge
        const response = await FlightTicket.orderTicketBlockonomics(
          first_name,
          last_name,
          email,
          airline,
          arrival_time,
          city_from,
          city_to,
          departure_time,
          flight_name,
          fly_duration,
          fly_from,
          fly_to,
          price,
          route,
          subscribe_to_newsletter,
          "5", // 5 times 1$ ticket price
          // Pro ticket extra options
          extraPassengers,
          currency,
          optionalPnrNumber,
          flightClass
        )
        const maybeText = await response.text();
        let data = {};
        try { data = JSON.parse(maybeText); } catch(e) { data = {}; }
        if (response.ok && data && (data.uid || (data.data && data.data.uid))) {
          const uid = data.uid || (data.data && data.data.uid);
          setBlockonomicsUid(uid);
        } else {
          setAlertType('warning');
          setAlertMessage('Could not prepare Bitcoin payment. Please try again in a moment.');
          setShowAlert(true);
        }
        // Keep widget hidden until user clicks the button
        setShowBlockonomicsWidget(false);
        // Defer opening the widget until the user explicitly clicks the button
        } finally {
          setIsLoadingBitcoin(false);
        }
    }
    setIsLoading(false);
  }

  /////////////////////////
  // Pro Ticket Functions
  const handleAddPassenger = () => {
    // Allow max 5 extra passengers
    if (extraPassengers.length < 5) {
      setExtraPassengers([...extraPassengers, {"name": ""}]);
    }
  };

  const handlePassengerChange = (event, index) => {
    const newPassengers = [...extraPassengers];
    newPassengers[index] = {"name": event.target.value};
    setExtraPassengers(newPassengers);
  };

  const handleDeletePassenger = (index) => {
    const newPassengers = [...extraPassengers];
    newPassengers.splice(index, 1);
    setExtraPassengers(newPassengers);
  }

  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value);
  }

  const handleFlightClassChange = (event) => {
    const selectedFlightClassText = event.target.options[event.target.selectedIndex].text;
    setFlightClass(selectedFlightClassText);
  }

  const handleOptionalPnrNumberChange = (event) => {
    setOptionalPnrNumber(event.target.value);
  }

  //////////////////////////////////////////////////////////


  ////////////////////////////////////////////////
  // JSX Components
  const free_ticket =
  <>
    <div className="row">
      <div className="col-lg-6">
        <ul className="list-unstyled text-left text-secondary">
          <li className="text-dark"><i className="bi bi-check text-success"></i> Real Flight Information (departure, arrival, airline, etc.)</li>
          <li><i className="bi bi-x text-warning"></i> Airline logos in ticket</li>
          <li><i className="bi bi-x text-warning"></i> Add additional passengers</li>
          <li><i className="bi bi-x text-warning"></i> Choose currency on ticket</li>
          <li><i className="bi bi-x text-warning"></i> Choose flight class</li>
          <li><i className="bi bi-x text-warning"></i> Verifiable on airline website</li>
        </ul>
      </div>
      <div className="col-lg-6">
        <ExampleTicket
          headline="Basic Ticket:"
          ticketImage="/images/basic_ticket.png"
        />
      </div>
    </div>
  </>

  const pro_ticket_custom_settings = 
  <>
    <Button
      onClick={() => setOpenProSettings(!openProSettings)}
      variant="outline-info"
      size="lg"
      className="mb-2"
      aria-expanded={openProSettings}
      aria-controls="pro-settings"
    >
      <span className="font-weight-bold">Customize Pro Ticket</span>
      <i className={`bi ${openProSettings ? 'bi-chevron-up' : 'bi-chevron-down'} ml-2`}></i>
      <i className="bi bi-star-fill text-warning ml-2" />
    </Button>
    <Collapse in={openProSettings}>
      <div id="pro-settings">
        <div className="row mt-4">
          <div className="col">
            <p className="text-left">
              <span className="font-weight-bold mr-2">Extra Passengers</span>
              <span className="text-secondary text-sm">(optional) </span>
              <span className="badge badge-success">max 5</span>
            </p>
            <div className="form-group">
            {extraPassengers.map((passenger, index) => (
              <div className="input-group mb-2" key={index}>
                <input
                    type="text"
                    id="extraPassenger"
                    value={passenger.name}
                    onChange={(e) => handlePassengerChange(e, index)}
                    className="form-control"
                    placeholder="Full Name"
                    maxLength="150"
                  />
                  <div className="input-group-prepend">
                    <button className="btn btn-light" onClick={() => handleDeletePassenger(index)}>
                      <i className="bi bi-x text-warning"></i>
                    </button>
                  </div>
              </div>
              ))}
            </div>
            {extraPassengers.length < 5 &&
            <button type="button" className="btn btn-outline-secondary btn-block" onClick={handleAddPassenger}>
              <i className="bi bi-plus"></i> Add Passenger
            </button>
            }
          </div>
        </div>

        <hr/>

        <div className="row">
          <div className="col text-left">
            <CurrencySelector currency={currency} onCurrencyChange={handleCurrencyChange} />
          </div>
          
          {/*
          <div className="col text-left">
            <label for="optionalPnrNumber">PNR Number <i className="bi bi-info-circle-fill" data-toggle="tooltip" data-placement="right" title="This is a tooltip"></i> <span className="text-secondary text-sm">(optional)</span></label>
            <input
            type="text"
            id="optionalPnrNumber"
            onChange={(e) => handleOptionalPnrNumberChange(e)}
            value={optionalPnrNumber}
            className="form-control"
            placeholder="PNR Number"
            maxLength="13"
            />
          </div>
          */}
        </div>

        <div className="row mb-3">
          <div className="col text-left">
            <label htmlFor="flightClass">Flight Class <span className="text-secondary text-sm">(optional)</span></label>
            <select
              type="text"
              id="flightClass"
              onChange={(e) => handleFlightClassChange(e)}
              className="form-control"
              placeholder="Flight Class"
              maxLength="50"
            >
              <option value="">Select Flight Class</option>
              <option value="economy">Economy</option>
              <option value="business">Business</option>
              <option value="first">First Class</option>
            </select>
          </div>
        </div>

      </div>
    </Collapse>
  </>

  const pro_ticket = 
  <>
    <div className="row">
      <div className="col-lg-6 text-left mb-4">
            <ul className="list-unstyled text-left">
              <li><i className="bi bi-check text-success"></i> Real Flight Information (departure, arrival, airline, etc.)</li>
              <li><i className="bi bi-check text-success"></i> Airline logos in ticket</li>
              <li><i className="bi bi-check text-success"></i> Add additional passengers</li>
              <li><i className="bi bi-check text-success"></i> Choose currency on ticket</li>
              <li><i className="bi bi-check text-success"></i> Choose flight class</li>
              <li><i className="bi bi-x text-warning"></i> Verifiable on airline website</li>
            </ul>
            {pro_ticket_custom_settings}
      </div>
      <div className="col-lg-6">
        <ExampleTicket
          headline="Pro Ticket:"
          ticketImage="/images/pro_ticket.png"
        />
      </div>
    </div>
  </>

  const free_ticket_body = 
  <>
    <Row>
      <Col
        align="center">
          {free_ticket}
      </Col>
    </Row>
  </>

  const pro_ticket_body = 
  <>
    <Row>
      <Col
        align="center">
          {pro_ticket}
      </Col>
    </Row>
  </>

  const compare_basic_pro_table = 
  <>
    <hr/>
    <table className="table table-light text-left" ref={upgradeDialogRef}>
      <thead>
        <tr>
          <th></th>
          <th>Basic</th>
          <th>Pro</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            Real Flight Information (departure, arrival, airline, etc.)
          </td>
          <td><i className="bi bi-check text-success"></i></td>
          <td><i className="bi bi-check text-success"></i></td>
        </tr>
        <tr>
          <td>
            Airline logos in ticket
          </td>
          <td><i className="bi bi-x text-danger"></i></td>
          <td><i className="bi bi-check text-success"></i></td>
        </tr>
        <tr>
          <td>
            Add additional passengers
          </td>
          <td><i className="bi bi-x text-danger"></i></td>
          <td><i className="bi bi-check text-success"></i></td>
        </tr>
        <tr>
          <td>
            Choose currency on ticket
          </td>
          <td><i className="bi bi-x text-danger"></i></td>
          <td><i className="bi bi-check text-success"></i></td>
        </tr>
        <tr>
          <td>
            Choose flight class
          </td>
          <td><i className="bi bi-x text-danger"></i></td>
          <td><i className="bi bi-check text-success"></i></td>
        </tr>
      </tbody>
    </table>
  </>

  const free_modal_footer =
  <>
    <Button
      size="lg"
      variant="primary"
      disabled={isLoading}
      onClick={() => setShowUpgradeDialog(true)}
      className="text-start w-100 text-center"
    >
      {isLoading ? 'Processing...' : 'Get Basic Ticket - Free'}
    </Button>

    {showUpgradeDialog && (
      <div className="text-center alert alert-light mt-4">
        <h5>Upgrade to Pro ticket?</h5>
        {compare_basic_pro_table}
        <Button
          size="lg"
          variant="secondary"
          onClick={() => handleGetFreeTicket()}
          style={{ margin: '10px' }}
        >
          No, just get a Basic ticket
        </Button>
        <Button
          size="lg"
          variant="primary"
          onClick={() => {
            setShowUpgradeDialog(false);
            setTabKey("pro");
          }}
          style={{ margin: '10px' }}
        >
          Yes, upgrade to Pro ticket
        </Button>
      </div>
    )}
  </>

const pro_modal_footer =
<>
  <Row>
  {constClass.ENABLE_COINBASE_PAYMENT &&
    <Col xs={12}>
        <Button
        size="lg"
        variant="primary"
        aria-label="Pay with Bitcoin"
          disabled={isLoadingBitcoin}
        onClick={() => { openBlockonomicsWidgetSimple(); }}
        className="text-start w-100 text-center"
      >
          {isLoadingBitcoin && (
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        )}
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-currency-bitcoin" viewBox="0 0 16 16">
          <path d="M5.5 13v1.25c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25V13h.5v1.25c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25V13h.084c1.992 0 3.416-1.033 3.416-2.82 0-1.502-1.007-2.323-2.186-2.44v-.088c.97-.242 1.683-.974 1.683-2.19C11.997 3.93 10.847 3 9.092 3H9V1.75a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25V3h-.573V1.75a.25.25 0 0 0-.25-.25H5.75a.25.25 0 0 0-.25.25V3l-1.998.011a.25.25 0 0 0-.25.25v.989c0 .137.11.25.248.25l.755-.005a.75.75 0 0 1 .745.75v5.505a.75.75 0 0 1-.75.75l-.748.011a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25L5.5 13zm1.427-8.513h1.719c.906 0 1.438.498 1.438 1.312 0 .871-.575 1.362-1.877 1.362h-1.28V4.487zm0 4.051h1.84c1.137 0 1.756.58 1.756 1.524 0 .953-.626 1.45-2.158 1.45H6.927V8.539z"/>
        </svg>
          {isLoadingBitcoin ? 'Preparing…' : showBlockonomicsWidget ? 'Close Bitcoin Payment' : `Pay $${PRO_PRICE_USD} with Bitcoin`}
      </Button>

      <div className={`mt-3 ${showBlockonomicsWidget ? 'p-3' : ''} d-flex justify-content-center`}>
        <div id="blockonomics_widget" className={!showBlockonomicsWidget ? 'd-none' : ''}></div>
      </div>
    </Col>
  }

  {constClass.ENABLE_PAYPAL_PAYMENT &&
    <Col xs={12} className="my-4">
      <div className="d-flex align-items-center my-3">
        <hr className="flex-grow-1" />
        <span className="mx-3 text-muted">or</span>
        <hr className="flex-grow-1" />
      </div>
      <p className="h5 text-center"><strong>{`Pay $${PRO_PRICE_USD} with PayPal`}</strong></p>
      <PaypalButton
        currency={constClass.CURRENCY}
        showSpinner={true}
        customer_data={props.customer_data}
        flight_data={props.flight_data}
        extra_data={props.extra_data}
        pro_ticket_options={{
          extraPassengers: extraPassengers,
          currencyOnTicket: currency,
          optionalPnrNumber: optionalPnrNumber,
          flightClass: flightClass
        }}
      />
    </Col>
    }
    {constClass.ENABLE_STRIPE_PAYMENT &&
    <Col xs={12}>
      <Button
        size="lg"
        variant="outline-primary"
        disabled={isLoadingStripe}
        onClick={!isLoadingStripe ? () => handleCheckout("stripe") : null}
        className="text-start w-100 text-center"
      >
        <i className="bi bi-credit-card-fill me-2"></i>&nbsp;&nbsp;
        {isLoadingStripe ? 'Processing...' : `Pay ${PRO_PRICE_USD} ${constClass.CURRENCY} by Card (Stripe)`}
      </Button>
    </Col>
    }
    <Col xs={12} className="text-center">
      <p><strong>Excellent </strong> 4.7 out of 5 based on <strong>145</strong> reviews &nbsp;&nbsp;
        <a href="https://www.trustpilot.com/review/onwardflightticket.com" target="_blank" rel="noopener">
          <svg width="100px" height="100px" viewBox="0 0 140 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M36.785 11.97h14.173v2.597h-5.572v14.602H42.32V14.567h-5.548v-2.598h.012zm13.568 4.745h2.62v2.404h.049c.087-.34.247-.668.482-.984a4.57 4.57 0 0 1 1.965-1.517 3.456 3.456 0 0 1 1.248-.243c.32 0 .556.012.68.025.123.012.246.036.382.048v2.646a9.09 9.09 0 0 0-.605-.085 5.198 5.198 0 0 0-.606-.036c-.47 0-.914.097-1.334.28-.42.181-.779.46-1.087.813a4.107 4.107 0 0 0-.742 1.335c-.185.534-.272 1.14-.272 1.833v5.923h-2.792V16.715h.012zM70.618 29.17h-2.743v-1.736h-.05c-.346.632-.852 1.13-1.532 1.506-.68.376-1.372.57-2.076.57-1.668 0-2.88-.4-3.62-1.214-.742-.813-1.113-2.039-1.113-3.678v-7.902h2.793v7.635c0 1.093.21 1.87.643 2.319.42.449 1.025.68 1.791.68.593 0 1.075-.085 1.47-.268.396-.182.717-.412.952-.716.247-.291.42-.655.532-1.068.11-.413.16-.862.16-1.347v-7.223h2.793V29.17zm4.757-3.993c.087.8.395 1.36.927 1.687.543.316 1.186.486 1.94.486.26 0 .556-.025.89-.061.333-.037.654-.122.939-.23.296-.11.53-.28.728-.498.186-.22.272-.498.26-.85a1.163 1.163 0 0 0-.395-.862c-.248-.23-.556-.4-.94-.546a9.56 9.56 0 0 0-1.31-.352c-.494-.097-.988-.207-1.494-.316a14.42 14.42 0 0 1-1.508-.413 4.632 4.632 0 0 1-1.297-.655 2.898 2.898 0 0 1-.915-1.044c-.234-.425-.346-.947-.346-1.578 0-.68.173-1.238.507-1.7a3.821 3.821 0 0 1 1.273-1.104 5.973 5.973 0 0 1 1.717-.595c.63-.109 1.236-.17 1.804-.17.655 0 1.285.073 1.879.207a4.885 4.885 0 0 1 1.618.667c.482.304.877.704 1.199 1.19.321.485.519 1.08.605 1.772H80.54c-.136-.655-.433-1.104-.914-1.323-.482-.23-1.038-.34-1.656-.34-.198 0-.433.012-.704.049a3.918 3.918 0 0 0-.767.182 1.666 1.666 0 0 0-.605.388.93.93 0 0 0-.247.668c0 .34.123.607.358.813.235.206.544.376.927.522.383.134.816.255 1.31.352.494.097 1 .206 1.52.316.506.109 1 .255 1.495.412.494.158.926.377 1.31.656.383.279.692.619.926 1.032.235.412.359.934.359 1.541 0 .74-.173 1.36-.52 1.882-.345.51-.79.934-1.334 1.25a6.34 6.34 0 0 1-1.829.704 9.334 9.334 0 0 1-1.99.218 8.585 8.585 0 0 1-2.223-.267c-.68-.182-1.273-.449-1.767-.8a3.99 3.99 0 0 1-1.174-1.348c-.284-.534-.433-1.178-.457-1.918h2.817v-.024zm9.218-8.46h2.113v-3.74h2.793v3.74h2.52v2.05H89.5v6.653c0 .29.012.534.037.752.024.207.086.389.173.534a.79.79 0 0 0 .407.328c.186.073.42.11.742.11.197 0 .395 0 .593-.013.198-.012.395-.036.593-.085v2.124c-.309.037-.618.061-.902.097a7.355 7.355 0 0 1-.902.049c-.741 0-1.334-.073-1.78-.206-.444-.134-.803-.34-1.05-.607-.259-.267-.42-.595-.519-.996a7.342 7.342 0 0 1-.16-1.371V18.79h-2.113v-2.076h-.025zm9.403 0h2.645v1.686h.05c.394-.728.938-1.238 1.642-1.553a5.499 5.499 0 0 1 2.287-.474c1 0 1.865.17 2.607.522.741.34 1.359.814 1.853 1.42.494.607.853 1.311 1.1 2.113a8.71 8.71 0 0 1 .371 2.573c0 .837-.111 1.65-.334 2.428a6.436 6.436 0 0 1-1.001 2.087 4.89 4.89 0 0 1-1.705 1.445c-.692.364-1.495.546-2.434.546a6.95 6.95 0 0 1-1.224-.11 5.455 5.455 0 0 1-1.173-.351 4.254 4.254 0 0 1-1.039-.62 3.871 3.871 0 0 1-.803-.873h-.05v6.215h-2.792V16.715zm9.762 6.238a6.11 6.11 0 0 0-.222-1.638 4.391 4.391 0 0 0-.668-1.408 3.374 3.374 0 0 0-1.099-.984 3.129 3.129 0 0 0-1.52-.376c-1.174 0-2.064.4-2.657 1.202-.593.801-.89 1.87-.89 3.204 0 .631.075 1.214.235 1.748.16.534.383.996.704 1.384.31.389.68.692 1.113.91.432.231.939.34 1.507.34.643 0 1.174-.133 1.619-.388a3.389 3.389 0 0 0 1.087-.995c.284-.413.495-.875.618-1.396a7.683 7.683 0 0 0 .173-1.603zm4.93-10.985h2.793v2.598h-2.793v-2.598zm0 4.746h2.793V29.17h-2.793V16.715zm5.289-4.746h2.793v17.2h-2.793v-17.2zm11.356 17.54c-1.014 0-1.916-.17-2.706-.497a5.977 5.977 0 0 1-2.014-1.36 5.908 5.908 0 0 1-1.249-2.076 7.888 7.888 0 0 1-.432-2.646c0-.947.148-1.82.432-2.622a5.91 5.91 0 0 1 1.249-2.075c.543-.583 1.223-1.032 2.014-1.36.79-.328 1.692-.498 2.706-.498 1.013 0 1.915.17 2.706.498.791.328 1.458.79 2.014 1.36a5.893 5.893 0 0 1 1.248 2.075c.284.801.432 1.675.432 2.622 0 .96-.148 1.845-.432 2.646a5.891 5.891 0 0 1-1.248 2.076c-.544.583-1.223 1.032-2.014 1.36-.791.327-1.693.497-2.706.497zm0-2.173c.618 0 1.161-.133 1.618-.388a3.42 3.42 0 0 0 1.125-1.008c.296-.412.506-.886.655-1.408.136-.522.21-1.056.21-1.602 0-.534-.074-1.056-.21-1.59a4.13 4.13 0 0 0-.655-1.408 3.386 3.386 0 0 0-1.125-.995c-.457-.255-1-.389-1.618-.389-.618 0-1.162.134-1.619.389a3.52 3.52 0 0 0-1.124.995 4.347 4.347 0 0 0-.655 1.408 6.387 6.387 0 0 0-.211 1.59c0 .546.075 1.08.211 1.602s.358.996.655 1.408c.296.413.667.753 1.124 1.008.457.267 1.001.388 1.619.388zm7.216-10.62h2.113v-3.74h2.793v3.74h2.52v2.05h-2.52v6.653c0 .29.012.534.036.752.025.207.087.389.174.534a.787.787 0 0 0 .407.328c.186.073.42.11.742.11.197 0 .395 0 .593-.013.198-.012.395-.036.593-.085v2.124c-.309.037-.618.061-.902.097a7.359 7.359 0 0 1-.902.049c-.741 0-1.335-.073-1.78-.206-.444-.134-.803-.34-1.05-.607-.259-.267-.42-.595-.519-.996a7.37 7.37 0 0 1-.16-1.371V18.79h-2.113v-2.076h-.025z" fill="#000000"/>
            <path d="M33.523 11.969H20.722L16.768 0 12.8 11.97 0 11.957l10.367 7.404-3.966 11.956 10.367-7.392 10.355 7.392-3.954-11.956 10.354-7.392z" fill="#04DA8D"/>
            <path d="m24.058 22.069-.89-2.707-6.4 4.564 7.29-1.857z" fill="#126849"/>
          </svg>
        </a>
      </p>
    </Col>
  </Row>
</>

  return (
        <Modal
          show={props.is_visible}
          onHide={props.handleCloseModal}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Get your ticket to {props.flight_data.city_to}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="justify-content-center"
          >
            <Row>
              <Col>
                <Tabs
                  id="controlled-tab-example"
                  activeKey={tabKey}
                  onSelect={(k) => setTabKey(k)}
                  className="mb-4 w-100"
                  fill
                >
                  {constClass.ENABLE_FREE_TICKET &&
                  <Tab 
                    eventKey="basic" 
                    title={
                      <span className="d-flex align-items-center justify-content-center gap-2">
                        <span>Basic</span>
                      </span>
                    }
                  >
                    {free_ticket_body}
                  </Tab>
                  }
                  {constClass.ENABLE_PRO_TICKET &&
                  <Tab 
                    eventKey="pro" 
                    title={
                      <span className="d-flex align-items-center justify-content-center gap-2">
                        <span>Pro</span>
                        <i className="bi bi-star-fill text-warning"></i>
                      </span>
                    }
                  >
                    {pro_ticket_body}
                  </Tab>
                  }
                </Tabs>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col>
                <p className="text-start">
                  Ticket will be sent to <strong>{props.customer_data.email}</strong> instantly after payment.
                </p>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col>
              {showAlert && (
                <Alert variant={alertType} onClose={() => setShowAlert(false)} dismissible role="alert">
                  {alertMessage}
                </Alert>
              )}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
              {tabKey === "basic" ? free_modal_footer : pro_modal_footer}
          </Modal.Footer>
        </Modal>
    );
}

export default PayWhatYouWantCheckout;